/**
 * Created by ZhangJunPeng on 2017/5/22.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Popover } from 'antd';
import { FormattedMessage } from 'react-intl';
import { CHINESE, ENGLISH, ROOM_NEED_AUDIT, SIGN_TYPE } from '../../utils/constants';
import RoomDetailPopover from '../commons/RoomDetailDialog';
import locationImg from '../../assets/icon-calendar-location.svg';
import peopleImg from '../../assets/icon-calendar-people.svg';
import roomImg from '../../assets/icon-calendar-room.svg';
import signImg from '../../assets/icon-calendar-sign.svg';
import roomIcon from '../../assets/roomIcon.png';
import {getSignTypeKey} from  '../../utils/meetingUtil';

class MeetingRoom extends React.Component {
  constructor(props) {
    super(props);
  }

  getNumberOfPeople(minNumber, maxNumber) {
    return minNumber + '-' + maxNumber;
  }

  render() {
    const { room, intl, dispatch, meetingPolicy } = this.props;
    let signInStr = intl.formatMessage({id: getSignTypeKey(String(room.sign))});

    const signAudit = [];
    if (String(room.sign) !== SIGN_TYPE.no) {
      signAudit.push(<span key={1}>{signInStr}</span>)
      if (room.audit === ROOM_NEED_AUDIT.yes) {
        signAudit.push(<span key={2}>&nbsp;|&nbsp;</span>)
      }
    }
    if (room.audit === ROOM_NEED_AUDIT.yes) {
      signAudit.push(<FormattedMessage key={3} id="need_audit" />)
    }

    const popoverTitle =
      <span className="popover-title">
        <img src={roomIcon} />
        {intl.locale === "en_US"?room.nameEn:room.name}
      </span>

    return (
      <Popover
        placement="rightTop"
        title={popoverTitle}
        content={
          <RoomDetailPopover
            intl={intl}
            dispatch={dispatch}
            locale={intl.formatMessage({ id: 'locale' })}
            room={room}
          />
        }
        trigger="hover"
        arrowPointAtCenter
        // mouseEnterDelay={1}
        overlayClassName="room-detail-popover"
      >
        <div className="table-left_div">
          <div title={intl.locale === ENGLISH?room.nameEn:room.name} className="name-area">
            <span>
              <img src={roomImg} />
            </span>
            <span className="room_span">{intl.locale === ENGLISH?room.nameEn:room.name}</span>
            {meetingPolicy.billingSwitch === 1 && (()=>{
                if(room.rates && room.rates > 0){
                  return <div className="price-circle">{`￥` + room.rates.toFixed(2)+`/h`} </div>;
                }else{
                  return <div className="price-circle">{intl.formatMessage({id:'price_free'})} </div>;
                }
            })()}
          </div>
          <div className="zone-container">
            <img src={locationImg} />
            <div className="zone-content">
              <div title={room.zoneFullName} className="zone-area">
                {room.zoneFullName}
              </div>
            </div>
          </div>

          <h2 className="table-left_div-bottom2 sign-area">
            { signAudit.length > 0 &&
              <span>
                <img src={signImg} />
                {signAudit}
              </span>
            }
          </h2>
          <h2 className="table-left_div-bottom sign-area">
            <span className="icon-area">
              <img src={peopleImg} />
              <FormattedMessage
                id="search_unit_person"
                values={{
                  num: this.getNumberOfPeople(room.minNumber, room.maxNumber)
                }}
              />
            </span>
          </h2>
        </div>
      </Popover>
    );
  }
}

MeetingRoom.propTypes = {
  room: PropTypes.object.isRequired
};

export default MeetingRoom;



// WEBPACK FOOTER //
// ./src/components/meeting/MeetingRoom.js